document.addEventListener('alpine:init', function() {
	Alpine.data('ViewSwitcher', () => ({
    view: 'grid',

    setView(view) {
      this.view = view;
      localStorage.setItem('view-mode', view);
    },

    isGrid() {
      return this.view === 'grid';
    },

    isList() {
      return this.view === 'list';
    },

    init() {
      const saved = localStorage.getItem('view-mode');
      if (saved === 'grid' || saved === 'list') {
        this.view = saved;
      }
    }
  }));
})